export const DAILY_STATUS_REQUEST = 'DAILY_STATUS_REQUEST'
export const DAILY_STATUS_SUCCESS = ' DAILY_STATUS_SUCCESS'
export const DAILY_STATUS_FAIL = 'DAILY_STATUS_FAIL'
export const DAILY_STATUS_RESET = 'DAILY_STATUS_RESET '